import { ShareScreenNavigationProps } from "./types"
import React from "react"
import Share from "./share-screen"
import { PageRoot } from "~screens/page-root"


const ShareScreen: React.FC<ShareScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <Share />
    </PageRoot>
  )
}

export default ShareScreen
